import { useState } from 'react';

import { Box } from '@opendoor/bricks/core';
import Field from '@opendoor/cinderblocks/growth/novo/inputs/Field';
import { IAccountFormProps } from '@opendoor/cinderblocks/platform/auth/AccountForm';

const AccountNameInput: IAccountFormProps['NameInput'] = ({ errorMessage, ...props }) => {
  const [hasError, setHasError] = useState(false);

  return (
    <Box textAlign="left">
      <Field
        errorText="Name is required"
        label={props.label}
        input={{
          id: props.id,
          error: hasError,
          onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
            const value = (event.target.value || '').trim();
            const isValid = !props.required || !!value;

            // Clear out any errors if we get a valid email
            if (value && isValid) {
              setHasError(false);
            }

            props.onChange(event, value, isValid);
          },
          onBlur: (event: React.FocusEvent<HTMLInputElement>) => {
            const value = (event.target.value || '').trim();

            if (!props.required || value) {
              setHasError(false);
            } else {
              setHasError(true);
            }
          },
          defaultValue: props.value ?? '',
          name: props.name,
          placeholder: props.placeholder,
        }}
      />
    </Box>
  );
};

export default AccountNameInput;
